import React from 'react';
import { Section } from './ui/Section';
import { Flame, Droplets, Crosshair, ListChecks, TrendingUp, Hand, ShieldCheck, BookOpenCheck } from 'lucide-react';
export function ScientificMethod() {
  const items = [{
    title: 'Sistema Manual Potenciado',
    desc: 'Técnicas manuales y protocolos claros para maximizar resultados sin pastillas ni cirugía.',
    Icon: BookOpenCheck
  }, {
    title: 'Absorción Rápida',
    desc: 'Protocolo de calentamiento y activación que mejora la respuesta del tejido desde la primera sesión.',
    Icon: Flame
  }, {
    title: 'Activación Eficiente',
    desc: 'Preparación y lubricación correcta para que cada ejercicio sea más efectivo y más seguro.',
    Icon: Droplets
  }, {
    title: 'Estimulación Precisa',
    desc: 'Técnicas de presión y ritmo para estimular donde importa y mejorar estética y rendimiento.',
    Icon: Crosshair
  }, {
    title: 'Ejecución Inteligente',
    desc: 'Método paso a paso para que tu cuerpo se adapte y el progreso sea medible semana a semana.',
    Icon: ListChecks
  }, {
    title: 'Respuesta Progresiva',
    desc: 'Sistema de carga gradual que permite avances constantes sin forzar ni arriesgar lesiones.',
    Icon: TrendingUp
  }, {
    title: 'Máxima Eficiencia Manual',
    desc: 'Secuencia optimizada que aprovecha mejor el tiempo y evita errores típicos de principiantes.',
    Icon: Hand
  }, {
    title: 'Seguridad y Control',
    desc: 'Reglas claras + señales de control para ajustar intensidad y evitar errores o sobreentrenamiento.',
    Icon: ShieldCheck
  }];
  return <Section background="accent" className="border-y border-[#22C55E]/10" data-id="element-146">
      <div className="text-center mb-12" data-id="element-147">
        <h2 className="text-3xl md:text-4xl font-bold text-white uppercase leading-tight" data-id="element-148">
          EL MÉTODO NATURAL PARA UNA{' '}
          <span className="text-[#FFD700]" data-id="element-149">
            MASCULINIDAD PLENA Y VISIBLE
          </span>
        </h2>
      </div>

      <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-150">
        
        {/* LISTA */}
        <div className="space-y-8" data-id="element-151">
          {items.map(({
          title,
          desc,
          Icon
        }, idx) => <div key={idx} className="flex gap-4" data-id="element-152">
              <div className="bg-[#22C55E]/10 p-3 rounded-lg h-fit" data-id="element-153">
                <Icon className="w-8 h-8 text-[#22C55E]" data-id="element-154" />
              </div>
              <div data-id="element-155">
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-156">
                  {title}
                </h3>
                <p className="text-gray-400" data-id="element-157">{desc}</p>
              </div>
            </div>)}
        </div>

        {/* IMAGEN COMPLETA SIN CORTE */}
        <div className="flex justify-center" data-id="element-158">
          <img src="https://i.ibb.co/KcrtK0fR/ad-Harto-de-prome-var-2.jpg" alt="Método Varamax" className="w-full max-w-full object-contain rounded-xl shadow-2xl border border-[#22C55E]/20" data-id="element-159" />
        </div>

      </div>
    </Section>;
}